var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 289.17 285.29",
    width: "220px",
    height: "220px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff7e1",
    cx: 142.64,
    cy: 142.64,
    r: 142.64
  }), /*#__PURE__*/React.createElement("g", {
    oopacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M164.93,249.41s-14.54,33.34-32.46,33.34S100,249.41,100,249.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M185.19,249.41s-14.53,33.34-32.46,33.34-32.46-33.34-32.46-33.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M235.89,249.41S221.36,262,203.43,262,171,249.41,171,249.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M210.71,249.41S196.18,268,178.25,268s-32.46-18.59-32.46-18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M140.82,249.41S126.29,268,108.36,268,75.9,249.41,75.9,249.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M114.32,249.41S99.78,262,81.86,262s-32.47-12.55-32.47-12.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M42.15,178.47c-3.66,1.2-10.87,28.79-8.51,38.15a2.6,2.6,0,0,0,5.08-1.08c-.13-4.54,3-28,7.83-31.79S42.15,178.47,42.15,178.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a",
    d: "M76.63,216.86c-10,.93-49.16,3.64-52.72,3.61-1.53,0-1.13,21.74-.83,24.05s5.12,1.11,6.74,1.12,41.9,4.53,51.68,3.21C98.65,246.54,101.57,214.53,76.63,216.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a",
    d: "M151.5,243.71c10-.39,49.28-1,52.83-.76,1.53.1,2.3-21.65,2.12-24s-5-1.38-6.66-1.49-41.6-6.77-51.44-6C131.1,212.89,126.46,244.7,151.5,243.71Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#b6b6dd",
    cx: 104.51,
    cy: 194.4,
    rx: 65.74,
    ry: 57.67
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M162.59,178.1c-19.29,15.69-25.86,48.21,5.41,59.36,3.67,1.32,25,15.2,32,13.53,6.76-1.61,4.41-5.85,8.28-4.87,15.87,4,63.18,2.3,70.13,2.3,7.78,0,8.21-3.31,9.64-6.45,3.77-8.3-2.75-6.95-11.92-6.38-10.31.64-16.94.45-33.06.45-9,0-18.81-4.86-17.8-12.21,1.95-14,3.43-21.6,3.45-25,0-10.07-7.17-22.47-20.76-26.61C193.91,168,175,168.6,162.59,178.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M213.67,223.7c-.78,3.59-2.26,5.46-5,4.87s-4.34-4-3.57-7.56c.12-.54,8.31-.77,11.05-.18S213.86,222.8,213.67,223.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.29,213.48c9.19,6.47,3,10.65,5.6,15.84,3.44,6.78,6.29,12.73,9.9,17.81,1.77,2.49,9,2.33,9.75,1.42-.65.74-4.59,6-17.71-1.57-7.25-4.2-11.66-5.46-11-12.38S179.29,213.48,179.29,213.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M135.22,251.69c9.86.76,48.5,4.71,51.95,5.34,1.5.27,4.82-21.23,4.92-23.56s-4.79-1.95-6.36-2.24a147.32,147.32,0,0,1-25-3.73c-10.1-2.6-20.4-8-24.82-8.15C118.85,218.73,110.54,249.78,135.22,251.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M71.19,222c-9.25.94-45.66,3.67-49,3.64-1.43,0-1.07,21.75-.79,24.06s4.75,1.1,6.26,1.11,60.4.19,69.58.31C116.44,251.31,94.36,219.6,71.19,222Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M177.09,169.1c-8.84-5.3-37.49,18.15-43.16,28-14.45,25.16,10.92,46.22,18,47.89s27.37-9.46,30.39-14.55S186.51,177.71,177.09,169.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a1a1c6",
    d: "M99,122.89s-6.65,10-8.1,11.5c-3.78,3.89-15.06,4-11.94-1,.35-.55,8.07-17.72,8.07-17.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M130.33,108.47c0,6.43-.12,13.49-3.79,17.58-5.49,6.12-12.88,10.31-22.36,10.31-9.66,0-17.3-4.94-22.63-10.88-3.54-4-3.52-10.81-3.52-17,0-18.73,11.71-33.92,26.15-33.92S130.33,89.74,130.33,108.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M83.81,103.12c0-5,.09-10.47,2.94-13.65a22.89,22.89,0,0,1,17.43-8c7.52,0,13.47,3.83,17.62,8.43,2.77,3.07,2.75,8.39,2.75,13.21,0,14.53-9.12,26.31-20.37,26.31S83.81,117.65,83.81,103.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M86.31,101.46c-6.14,8.07-6.56,14.85-4.59,22.69,1,3.81-2.58,1.42-4.39-3.11-1.25-.11-3.76-5.49-2.12-18.5C76.88,89.3,88.69,80.45,89.88,84,93.27,85,95,90,86.31,101.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6dd",
    d: "M122,101.46c6.14,8.07,6.57,14.85,4.59,22.69-1,3.81,2.58,1.42,4.39-3.11,1.26-.11,3.77-5.49,2.13-18.5C131.48,89.3,119.66,80.45,118.47,84,115.09,85,113.34,90,122,101.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 89.9,
    y: 132.34,
    width: 4.54,
    height: 6.74,
    rx: 2.27,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 94.45,
    y: 132.34,
    width: 4.54,
    height: 6.96,
    rx: 2.27,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 98.99,
    y: 132.34,
    width: 4.54,
    height: 6.61,
    rx: 2.27,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 106.69,
    y: 132.34,
    width: 4.54,
    height: 6.74,
    rx: 2.27,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 111.24,
    y: 132.34,
    width: 4.54,
    height: 6.96,
    rx: 2.27,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 115.78,
    y: 132.34,
    width: 4.54,
    height: 6.61,
    rx: 2.27,
    ry: 2.27
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 89.9,
    y: 136.21,
    width: 13.63,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#f4df87",
    x: 106.69,
    y: 136.21,
    width: 13.63,
    height: 3.08
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M132.94,86.71a28.83,28.83,0,1,1-57.66,0c0-15.92,12.91-25.38,28.83-25.38S132.94,70.79,132.94,86.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M137,81.3c-4-4.54-8.84-9.92-11.6-12.29-3.45-3-4.44-3.14-8.72,5.64C111.27,85.66,144.37,89.68,137,81.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5a4d8",
    d: "M71.33,81.64C75.2,77,79.84,71.43,82.53,69c3.35-3.07,4.33-3.28,8.89,5.35C97.15,85.16,64.19,90.25,71.33,81.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M102.48,94.45c-.22,5.48-5.17,9-12.06,9S78.94,100,78.94,94.53c0-3.42,4.8-8.52,12.77-8.21C99.92,86.63,102.65,90.24,102.48,94.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102,94.59c0,4.91-5,8.88-11.14,8.88s-10.59-2.2-10.59-7.11c0-3,2.46-7.12,11.94-7.1C100.23,89.27,102,92.38,102,94.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M97.68,97.5c0,2.65-1.65,4.8-3.67,4.8s-3.67-2.15-3.67-4.8C90.34,96.51,97.68,96.51,97.68,97.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4df87",
    points: "99.38 103.31 108.85 103.31 104.11 111.06 99.38 103.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9574a8",
    d: "M105.94,94.45c.22,5.48,5.17,9,12.07,9s11.48-3.45,11.48-8.94c0-3.42-4.81-8.52-12.77-8.21C108.51,86.63,105.78,90.24,105.94,94.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M106.47,94.59c0,4.91,5,8.88,11.14,8.88s10.58-2.2,10.58-7.11c0-3-2.45-7.12-11.94-7.1C108.19,89.27,106.47,92.38,106.47,94.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M110.75,97.5c0,2.65,1.64,4.8,3.67,4.8s3.67-2.15,3.67-4.8C118.09,96.51,110.75,96.51,110.75,97.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a",
    d: "M207.34,208.43c-1.19.49,2.5,2.95,5.38,1.75l8.31-3.46c1.05-.44,1.47-4.61-1.11-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M79.09,248.19c-9.1,2-47-.8-50.34-.84-1.42,0-7.59,0-7.31,2.3s4.75,1.1,6.26,1.11L89,251c9.91,1.88,32.2,1.07,41.41-1.16C130.38,249.84,102.92,243.05,79.09,248.19Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTired);
export default __webpack_public_path__ + "static/media/Tired.983f4f166de55af7b1194ee2ea1170b1.svg";
export { ForwardRef as ReactComponent };